// food-controller.js
import { addFeedRecord } from '../requests/profiles.js';
import { getNick, getSelectedProfileId } from '../state-manager.js';
import { resetSlider } from './ui-slider.js';

export class FoodInteractionController {
  constructor(containerSelector) {
    this.container = document.querySelector(containerSelector);
    this.rows = [];
    this.amount = 0;
    this.active = false;
    // console.log('[FoodController] Container:', this.container);
    // console.log('[FoodController] Container nodeType:', this.container?.nodeType);
    // console.log('[FoodController] created for OuterHTML:', this.container?.outerHTML); 
    console.log('[FoodController] created');
  }

  bind() {
    // this.rows = Array.from(this.container.querySelectorAll('.food-row'));
    // this.rows = Array.from(this.container.querySelectorAll('tr.food-row, .food-row')); 
    // this.rows = Array.from(this.container.children);   
    // console.log('[FoodController] Container innerHTML:', this.container.innerHTML);
    this.rows = Array.from(this.container.children).filter(row =>
      row.classList.contains('food-row')
    );   
    // console.log('[FoodController] Bound rows:', this.rows.length, this.rows);
    this.rows.forEach(row => {
      row.addEventListener('click', (e) => this._handleClick(e, row));
    });
  }

  activate(portionAmount) {
    this.amount = portionAmount;
    this.active = true;
    console.log('[FoodController] Activating with amount:', this.amount);
    this.rows.forEach(row => {
      if (!row.dataset.listenerAttached) {
        row.dataset.listenerAttached = 'true';
      }
      row.classList.add('active-food');
      row.dataset.clickable = 'true';
    });
  }

  deactivate() {
    this.active = false;
    this.amount = 0;
    this.rows.forEach(row => {
      row.classList.remove('active-food');
      delete row.dataset.clickable;
      delete row.dataset.clicked;
    });
  }

  _handleClick(event, row) {
    // console.log('[FoodController] Row clicked before:', row.dataset.foodId);
    if (!this.active || row.dataset.clicked === 'true') return;
    // console.log('[FoodController] Row clicked after:', row.dataset.foodId);
    row.dataset.clicked = 'true';
    const foodId = row.dataset.foodId;
    if (!foodId) {
      console.warn('[FoodController] No food ID found');
      return;
    }

    const nick = getNick();
    const profileId = getSelectedProfileId();

    addFeedRecord(profileId, foodId, this.amount, nick);
    this.deactivate();
    resetSlider();
  }
}